import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";
import { selectProjectNo } from "../sharedSelectors";
import type { IRootState } from "../app/store";
import {
  selectSpecifiedArticlesActiveSnapshot,
  selectSpecifiedArticlesValidation,
} from "../DesignTab/ModuleBars/DrofusOccurrenceValidationBarSelectors";

const selectRootState = (state: IRootState) => state;

export const selectArticleExclusionSettings = createSelector(
  [selectProjectNo, selectRootState],
  (projectNo, state) =>
    openapi.endpoints.getMultiplacerProjectArticleValidation.select({ projectNo })(state).data
);
export const selectIgnoredArticleCodes = createSelector(
  [selectArticleExclusionSettings],
  (settings) =>
    new Set(
      (settings?.ignoredCompCodes ?? [])
        .map((exclusion) => exclusion.compCode.trim())
        .filter(Boolean)
    )
);
export const selectIgnoredArticleRows = createSelector(
  [selectSpecifiedArticlesActiveSnapshot],
  (snapshot) =>
    [...(snapshot?.ignoredComparison ?? [])].sort((a, b) => a.compCode.localeCompare(b.compCode))
);
export const selectArticleExclusionsPending = createSelector(
  [selectIgnoredArticleCodes, selectArticleExclusionSettings, selectSpecifiedArticlesValidation],
  (codes, settings, snapshot) => {
    if (!settings || !snapshot) return false;
    if (!snapshot.appliedSettings) return codes.size > 0;
    const applied = new Set(
      snapshot.appliedSettings.ignoredCompCodes
        .map((exclusion) => exclusion.compCode.trim())
        .filter(Boolean)
    );
    return codes.size !== applied.size || [...codes].some((code) => !applied.has(code));
  }
);
export const selectNoActiveArticleRows = createSelector(
  [selectSpecifiedArticlesActiveSnapshot],
  (snapshot) => snapshot?.summary.itemsTotal === 0
);
